module.exports = __webpack_public_path__ + "img/32-firefox.c3479dd2.png";